'use strict';

import $ from 'jquery';
import { viewport } from './utilities/viewport';
import { debounce } from './utilities/debounce';

$(document).ready(function(){

	if ($('.paragraph--type--stages').length) {
		let submissionStagesHeader = $('.standard-page-content .stage-header');

		let setupForSmallerScreens = function(){
			$('.stages-panel, .stages-panel a').attr('tabindex','');

			submissionStagesHeader.attr('tabindex','0');
			submissionStagesHeader.attr('aria-expanded','false');
			$('.stage-link').attr('tabindex','');
		}

		let setupForLargerScreens = function(){
			submissionStagesHeader.attr('tabindex','-1');
		}

		//if smaller screens.
		if ( viewport().width < 1070 ) {
			setupForSmallerScreens();
		} else {
			setupForLargerScreens();
		}

		$(window).on('resize', debounce(function(){

			if ( viewport().width > 1070 ) {
				setupForLargerScreens();
			} else {
				setupForSmallerScreens();
			}

		}, 250));

		//if desktop and mobile
		let stagesTab = $('.paragraph--type--stages li[role="tab"]');
		if ( viewport().width >= 1070 ) {
			$('.paragraph--type--stages .stages-panel[id!="stage1"] a').attr('tabindex', '-1');
			$('.paragraph--type--stages li[role="tab"][id!="tab1"]').attr('tabindex', '-1');
		}
		stagesTab.on('click', function(){
			$(this).siblings().attr("aria-selected","false");
			$(this).siblings().attr('tabindex', '-1');
			$(this).attr("aria-selected","true");
			let tabpanid= $(this).attr("aria-controls");
			if ( viewport().width >= 1070) {
				$(this).parent().siblings().attr("aria-hidden","true").find('a').attr('tabindex', '-1');
			}
			$("#"+tabpanid).attr("aria-hidden","false").find('a').attr('tabindex', '0');
		})

		// keyboard navigation - tab
		stagesTab.keydown(function(e) {
			var key = (e.keyCode ? e.keyCode : e.which);
			if (key == 13 ) {
				$(this).click()
			}
		});

		// keyboard navigation - arrow left and arrow right
		stagesTab.keydown(function(e) {
			let tabpanid;
			if (e.which ==39 && $(this).next().length) {
				$(this).siblings().addBack().attr("aria-selected","false");
				$(this).next().attr("aria-selected","true").focus();
				$(this).siblings().addBack().attr('tabindex', '-1');
				$(this).next().attr('tabindex', '0');
				tabpanid= $(this).next().attr("aria-controls");
				if ( viewport().width >= 1070 ) {
					$(this).parent().siblings().attr("aria-hidden","true").find('a').attr('tabindex', '-1');
				}
				$("#"+tabpanid).attr("aria-hidden","false").find('a').attr('tabindex', '0');
				$(this).parent().siblings().attr('tabindex', '-1');
			} else if (e.which ==37 && $(this).prev().length) {
				$(this).siblings().addBack().attr("aria-selected","false");
				$(this).prev().attr("aria-selected","true").focus();
				$(this).siblings().addBack().attr('tabindex', '-1');
				$(this).prev().attr('tabindex', '0');
				tabpanid= $(this).prev().attr("aria-controls");
				if ( viewport().width >= 1070 ) {
					$(this).parent().siblings().attr("aria-hidden","true").find('a').attr('tabindex', '-1');
				}
				$("#"+tabpanid).attr("aria-hidden","false").find('a').attr('tabindex', '0');
				$(this).parent().siblings().attr('tabindex', '-1');
			}
		});
	}
})
